import { createSelector } from 'reselect';

export type DisplaySettingsState = {
  isInterviewSchedulePromptEnabled: boolean;
  jobLocationFilters: SelectOption<JobLocation>[];
  jobStatusFilters: SelectOption<JobStatus>[];
  lastVisitedOrgId: number | string | null;
  hasDismissedQuickbooksAnnouncement: boolean;
  hasDismissedImportEmployeeListMessage: boolean;
  hideDisabledCalendarEvents: boolean;
  calendarEventFilters: SelectOption<string>[];
};
// we can't type the keys of the user specific state because it's keyof DisplaySettingsState + - + username
// since we don't know the user's username it's just arbitrarily a string
type UserSpecificState = { [k: string]: any };

type State = { displaySettings: DisplaySettingsState & UserSpecificState };

export const displaySettingsSelector = (state: State) => state.displaySettings;

export const jobLocationFilters = createSelector(
  [displaySettingsSelector, (_state: State, username: string | null) => username],
  (displaySettings, username) =>
    displaySettings[`jobLocationFilters-${username}`] || displaySettings.jobLocationFilters,
);

export const jobStatusFilters = createSelector(
  [displaySettingsSelector, (_state: State, username: string | null) => username],
  (displaySettings, username) =>
    displaySettings[`jobStatusFilters-${username}`] || displaySettings.jobStatusFilters,
);

export const showAllJobsSelector = createSelector(
  [displaySettingsSelector, (_state: State, username: string | null) => username],
  (displaySettings, username) => displaySettings[`showAllJobs-${username}`],
);

export const lastVisitedOrgIdSelector = createSelector(
  [displaySettingsSelector, (_state: State, username: string) => username],
  (displaySettings, username) => displaySettings[`lastVisitedOrgId-${username}`],
);

export const hasDismissedQuickbooksAnnouncementSelector = createSelector(
  [displaySettingsSelector, (_state: State, username: string) => username],
  (displaySettings, username) => displaySettings[`hasDismissedQuickbooksAnnouncement-${username}`],
);

export const hasDismissedImportEmployeeListMessageSelector = createSelector(
  [displaySettingsSelector, (_state: State, username: string) => username],
  (displaySettings, username) =>
    displaySettings[`hasDismissedImportEmployeeListMessage-${username}`],
);

export const calendarEventFilters = createSelector(
  [displaySettingsSelector, (_state: State, username: string | null) => username],
  (displaySettings, username) =>
    displaySettings[`calendarEventFilters-${username}`] || displaySettings.calendarEventFilters,
);

export const hideCalendarDisabledEvents = createSelector(
  [displaySettingsSelector, (_state: State, username: string | null) => username],
  (displaySettings, username) => displaySettings[`hideCalendarDisabledEvents-${username}`],
);
